import React, { useState } from 'react';

import BlockContent from './BlockContent';
import Button from './Button';

export default function FaqSection({ section }) {
  const { references, blockContent } = section;

  const Question = ({ question }) => {
    const [isQuestionExpanded, setIsQuestionExpanded] = useState(false);

    const { button, title, description, link } = question;

    const style = () =>
      `question ${isQuestionExpanded ? '--active animate' : ''}`;

    return (
      <div
        className={style()}
        onClick={
          !isQuestionExpanded
            ? () => setIsQuestionExpanded(!isQuestionExpanded)
            : null
        }
      >
        <BlockContent
          content={{
            isDescriptionSmall: true,
            description: isQuestionExpanded ? description : null,
            headingThree: title,
            buttons: isQuestionExpanded
              ? [{ ...button, href: link, version: 'primary-text' }]
              : null
          }}
        />
        <Button
          onClick={() => setIsQuestionExpanded(!isQuestionExpanded)}
          button={{
            icon: isQuestionExpanded
              ? 'MdKeyboardArrowUp'
              : 'MdKeyboardArrowDown',
            version: 'wrapper'
          }}
        />
      </div>
    );
  };

  return (
    <div className="faq-section">
      <BlockContent content={blockContent} />
      <div className="faq-section__questions">
        {references?.map((r) => (
          <Question question={r} key={r.id} />
        ))}
      </div>
    </div>
  );
}
